import { useDictStore } from "@/stores/dictStore";

import { PricingStrategy, PriceResult } from "../base/pricing.strategy";
import { OverdoorAssetsCode } from "@/app/constants";

export class OverdoorAssetsPricingStrategy extends PricingStrategy {
    private dictStore = useDictStore();

    public getPrices(): PriceResult {
        const pricesFromDict =
            this.dictStore.findAssetsPrice(OverdoorAssetsCode);

        if (!this.validatePricesFromDict(pricesFromDict)) {
            return this.getDefaultPrices();
        }

        return {
            price: pricesFromDict.price!,
            priceB2C: pricesFromDict.priceB2C!,
            priceB2B: pricesFromDict.priceB2B!,
        };
    }
}
